import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { DEFAULT_LANG, LANGS, tFor } from "./strings";

const LS_KEY = "si_lang";
const I18nContext = createContext({ lang: DEFAULT_LANG, setLang: () => {}, t: (k) => k });

/** Read lang from localStorage (or default Hinglish). Validates against known LANGS. */
function readLang() {
  try {
    const stored = localStorage.getItem(LS_KEY);
    if (stored && LANGS.some((l) => l.code === stored)) return stored;
  } catch (_) { /* SSR / private mode */ }
  return DEFAULT_LANG;
}

export function I18nProvider({ children }) {
  const [lang, setLangState] = useState(readLang);

  // Update <html lang="..."> for accessibility / SEO
  useEffect(() => {
    if (typeof document !== "undefined") {
      const code = lang === "hindi" ? "hi" : lang === "hinglish" ? "hi-en" : "en";
      document.documentElement.setAttribute("lang", code);
    }
  }, [lang]);

  const setLang = useCallback((next) => {
    try { localStorage.setItem(LS_KEY, next); } catch (_) { /* ignore */ }
    setLangState(next);
  }, []);

  const t = useCallback((key, vars) => tFor(lang, key, vars), [lang]);

  return (
    <I18nContext.Provider value={{ lang, setLang, t }}>
      {children}
    </I18nContext.Provider>
  );
}

export function useI18n() {
  return useContext(I18nContext);
}

/** Shorthand: useT() returns just the t() function */
export function useT() {
  return useI18n().t;
}
